module.exports = __webpack_public_path__ + "img/wiaa_white.3d6ed8f2.png";